import './FieldSet.css';
export var fieldset = '_1dphm0f0-3-15-1';
export var legend = '_1dphm0f1-3-15-1';